import ModalError from './error/ModalError'
import ModalSuccess from './success/ModalSuccess'

export {
  ModalError,
  ModalSuccess,
}
